import { RootState } from "../../store"
import { mapUrlToBreadcrumbs } from "../helpers/parse-route"
import { createSelector } from "@reduxjs/toolkit"

const getCurrentPath = (state: RootState): string =>
  state.router.location?.pathname ?? ""

const getPageTitle = (state: RootState): Record<string, string | null> | null =>
  state.navigation.pageToTitle

export const getBreadcrumbs = createSelector(
  [getCurrentPath, getPageTitle],
  mapUrlToBreadcrumbs
)
